import { AlertTriangle } from "lucide-react";

// Bandeau d'environnement : affiché UNIQUEMENT sur les URLs de preview/test.
// Objectif : empêcher toute confusion entre l'environnement de TEST (preview)
// et la PRODUCTION (bases de données séparées, données identiques par seed).
export default function EnvBanner() {
  const host = typeof window !== "undefined" ? window.location.hostname : "";
  const isPreview =
    host.includes("preview.emergentagent.com") ||
    host.includes("localhost") ||
    host.includes("127.0.0.1");

  if (!isPreview) return null;

  return (
    <div
      data-testid="env-banner-preview"
      className="fixed bottom-0 inset-x-0 z-[60] flex items-center justify-center gap-2 border-t border-amber-300 bg-amber-500 px-3 py-1.5 text-center text-xs font-semibold text-black shadow-[0_-2px_12px_rgba(0,0,0,0.15)] sm:text-sm"
    >
      <AlertTriangle className="h-4 w-4 shrink-0" strokeWidth={2.5} />
      <span>
        ENVIRONNEMENT DE TEST (PREVIEW) — les données ne sont PAS celles de la production.
        <span className="ml-1 hidden font-mono font-normal opacity-70 sm:inline">{host}</span>
      </span>
    </div>
  );
}
